import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { MENU } from "@store/theme/design";
import { menuMobileButtonIconSizeStyles } from "@store/theme/mixins";
import { buttonResetProps } from "@store/theme/props/button";
import { css } from "styled-components";

export const menuMobileButtonProps: ButtonPresentationProps = {
    ...buttonResetProps,
    shape: "rectangle",
    // "any" to prevent deep type instantiation
    css: css<any>`
        ${buttonResetProps.css}
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 ${MENU.mobileButtonSpacing};
        font-size: inherit;
        transition: none;

        &:focus {
            outline-offset: -${props => props.theme.focus?.width};
        }

        ${ButtonIcon} {
            top: auto;
        }

        ${IconWrapper} {
            ${menuMobileButtonIconSizeStyles()}
        }
    `,
};
